import { CModal,CModalBody,CImage,CFormSelect,CFormTextarea,CFormLabel,CButton, CContainer, CNavbar, CFormCheck ,CRow,CCol, CForm, CCardBody,CCard, CFormInput, CFormFeedback} from '@coreui/react';
import CIcon from '@coreui/icons-react'
import { cilSend } from '@coreui/icons';
import {  useHistory } from 'react-router-dom';
import  "./../css/tbn/tbnFormCoplaint.css"
import '@coreui/coreui/dist/css/coreui.min.css'
import Moment from "moment"
import "react-datepicker/dist/react-datepicker.css";
import { initializeApp } from 'firebase/app';
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import { getFirestore, collection,  addDoc } from "firebase/firestore"
import {getStorage,ref,uploadBytes,getDownloadURL} from "firebase/storage";
import {  useEffect , useRef, useState ,} from 'react';
import ProvinceJson from '../file/provinces.json'
import DistrictsJson from '../file/districts.json'
import SubDistrictsJson from '../file/subdistricts.json'
import logo from './../img/tbn-logo-white.png'
import circle from './../img/Icon feather-check-circle.svg'


function TBNFormComplaint() {

    const app = useRef();
    const history = useHistory();
    const [listDistrict,setListDistrict]=useState([]);
    const [listSubDistrict,setListSubDistrict]=useState([]);
    const [toggleModal,setToggleModal] = useState(false)
    const [toggleConsentModal,setToggleConsentModal] = useState(false)
    const [validated,setValidated] = useState(false)
    const [checkDistrict,setCheckDistrict] = useState(true);
    const [checkSubDistrict,setCheckSubDistrict] = useState(true)
    const [refId,setRefId] = useState("");
    const [firstName,setFirstName] = useState("");
    // const [txtPinErr,setTxtPinErr] = useState("");
    const [txtFileErr,setTxtFileErr] = useState("");
    const [lastName,setLastName] = useState("");
    const [address,setAddress] = useState("");
    const [district,setDistrict] = useState("");
    const [subDistrict,setSubDistrict] = useState("");
    const [province,setProvince] = useState("");
    const [postcode,setPostcode] = useState("");
    const [telephone,setTelephone] = useState("");
    const [email,setEmail] = useState("");
    const [appeal,setAppeal]=useState("");
    const [place,setPlace]=useState("");
    const [company,setCompany]=useState("");
    const [person,setPerson]=useState("");
    const [provinceAcc,setProvinceAcc]=useState("");
    const [amount,setAmount]=useState("");
    const [description,setDescription]=useState("");
    const [file,setFile] = useState([]);
    const [fileDescription,setFileDescription]=useState("");
    // const [pin,setPin]=useState("");
    // const [confirmPin,setConfirmPin]=useState("");
    const companyList = ["BOP","TBN SOFTWARE"]
    const [consent,setConsent]=useState(false);
    const [followEmail,setFollowEmail] = useState(false);

    const [dateAcc, setDateAcc] = useState(Moment(new Date()).format('YYYY-MM-DD'));

   
    const listProvince = ProvinceJson.map((item) =>
    <option value={item.province_name} id={item.id} key={item.id}>{item.province_name}</option>
    );
    const optionCompany = companyList.map((item) =>
    <option value={item} id={item} key={item}>{item}</option>
    );
    let specialText = "!$&|~`#{}[]:;<>?";

    useEffect(() => {
      const firebaseConfig = {
        apiKey: 'AIzaSyBQYzkjpgplAbS05uIa4PDYXeKBhlScEWU',
        authDomain: 'bopproject-99315.firebaseapp.com',
        projectId: 'bopproject-99315',
        storageBucket: 'bopproject-99315.appspot.com',
        messagingSenderId: '553428492238',
        appId: '1:553428492238:web:82baf29cc4540d1cf3959f'
      };
      
      app.current = initializeApp(firebaseConfig);
      
      window.self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
      
      const appCheck = initializeAppCheck(app.current, {
        provider: new ReCaptchaV3Provider('6LdraCEdAAAAAGAlTJVWUIRDF0OsTpEDbrheyhiB'),
      
        // Optional argument. If true, the SDK automatically refreshes App Check
        // tokens as needed.
        isTokenAutoRefreshEnabled: true
      });
    }, []);

    const addDataFireBase =   async () => {

      const docData = {
        firstName:firstName,
        lastName:lastName,
        address:address,
        district:district,
        subDistrict:subDistrict,
        province:province,
        postcode:postcode,
        telephone:telephone,
        email:email,
        appeal:appeal,
        place:place,
        company:company,
        person:person,
        provinceAcc:provinceAcc,
        amount:amount,
        description:description,
        fileDesciption:fileDescription,
        // pin:pin,
        consent:consent,
        followEmail:followEmail,
        dateAcc:Moment(dateAcc).format('DD/MM/YYYY')
      }

       const db = getFirestore(app.current);
       var docRef = await addDoc(collection(db, 'TBN_Complaint_List'),docData)
       await uploadFileToFirebase(db,docRef.id);
       
       setRefId(docRef.id);
       
    }
    const returnMain = () =>{
      let path = '/';
      history.push({
          pathname: path
        });

    }
    const handleSubmit =  async (event) =>{
      const form = event.currentTarget
      // if(validatePin(event))
      // {
          if(form.checkValidity()===false)
        {
          event.preventDefault()
          event.stopPropagation()
          setValidated(true);
        }
        else{
          event.preventDefault()
          await addDataFireBase();
          setToggleModal(true);
        }
      // }
      

    }
    // const validatePin = (event) => {
    //   event.preventDefault();
    //   if(pin === "")
    //   {
    //     setTxtPinErr("")
    //     return true
    //   }
    //   else{
    //     if(pin.length<8)
    //     {
    //       //msg err
    //       setTxtPinErr("กรุณากรอก PIN ที่มีความยาวตั้งแต่ 8 ตัวอักษรขึ้นไป")
    //       return false
    //     }
    //     else if(pin !== confirmPin)
    //     {
    //       setTxtPinErr("กรุณาตรวจสอบ PIN กัย CONFIRM PIN อีกครั้ง")
    //       return false
    //     }
    //     else
    //     {
    //       setTxtPinErr("")
    //       return true
    //     }
    //   }
    // }
    const handleCloseModal = () => {
      setToggleModal(false);
      returnMain();
    }
    const handleAppeal = (e) => {
      setAppeal(e.target.value);
    }
    const handleAmount = (e) => {
      setAmount(e.target.value);
    }
    const hanldePlace = (e) => {
      setPlace(e.target.value);
    }
    const handleCompany = (e) => {
      setCompany(e.target.value);
    }
    const handlePerson = (e) => {
      setPerson(e.target.value);
    }
    const handleProvinceAcc = (e) => {
      setProvinceAcc(e.target.value);
    }
    const handleDescription = (e) => {
      // var re = /^[A-Za-zก-ฮ0-9()+-/*]+$/
      var una = /^[!$?&|~`#{}[:;<>]+$/
      var lastChar = e.target.value[e.target.value.length-1];
      if(e.target.value ==="" || (!una.test(e.target.value) && !una.test(lastChar) && lastChar !== "]" ))
      {
      setDescription(e.target.value);
      }
    }
    const handleFileDescription = (e) => {
      setFileDescription(e.target.value);
    }
    // const handlePin = (e) => {
    //   setPin(e.target.value);
    // }
    // const handleConfirmPin = (e) => {
    //   setConfirmPin(e.target.value);
    // }
    const handleConsent = (e) => {
      setConsent(e.target.checked);
    } 
    const handleFollowEmail = (e) => {
      setFollowEmail(e.target.checked);
    }
    const handleFirstName = (e) => {
      setFirstName(e.target.value);
    }
    const handleLastName = (e) => {
      setLastName(e.target.value);
    }
    const handleAddress = (e) => {
      setAddress(e.target.value);
    }
    const handleDistrict = (e) => {
      setDistrict(e.target.value);
      let listTmp = [];
      SubDistrictsJson.forEach((item) =>{
        var id = e.target.childNodes[e.target.selectedIndex].getAttribute('id')
          if(parseInt(id)===parseInt(item.district_id)){
            listTmp.push(<option value={item.subdistrict_name} id={item.id} key={item.id}>{item.subdistrict_name}</option>)
          }
      })
      setListSubDistrict(listTmp);
      if(listTmp.length>0) setCheckSubDistrict(false);
      setPostcode("");

    }
    const handleSubDistrict = (e) => {
      setSubDistrict(e.target.value);
      SubDistrictsJson.forEach((item) =>{
        var id = e.target.childNodes[e.target.selectedIndex].getAttribute('id')
        if(parseInt(id)===parseInt(item.id)){
          setPostcode(item.zip_code);
        }
    })
     if(e.target.value==="") setPostcode("");
    }
    const handleProvince = (e) => {
      setProvince(e.target.value);
      let listTmp = [];
      DistrictsJson.forEach((item) =>{
          if(parseInt(e.target.selectedIndex)===parseInt(item.province_id)){
            listTmp.push(<option value={item.district_name} id={item.id} key={item.id}>{item.district_name}</option>)
          }
      }
      )
      if(listTmp.length>0) setCheckDistrict(false);
      setListDistrict(listTmp);
      setListSubDistrict([]);
      setPostcode("");
      setCheckSubDistrict(true);
    }
    const handlePostcode = (e) => {
      const re = /^[0-9\b]+$/
      
      if(e.target.value ==="" || re.test(e.target.value))
      {
        setPostcode(e.target.value);
        
      }
      
    }
    const handleTelephone = (e) => {
      
      const re = /^[0-9\b]+$/
      if(e.target.value ==="" || re.test(e.target.value))
      {
        setTelephone(e.target.value);
      }
    }
    const handleEmail = (e) => {
      setEmail(e.target.value);
    }

    const fileSelected = (event) => {
      if(event.target.files.length>0){

      let lengthFiles = event.target.files[0].name.length;
      let sizeFiles = event.target.files[0].size;
      let fileName = event.target.files[0].name;
      var re =/(\.JPG|\.PNG|\.GIF|\.PDF|\.DOC|\.DOCX|\.XLS|\.XLSX|\.PPT|\.PPTX)$/i;
      if(sizeFiles>=3145728 || lengthFiles>50)
      {
        setFile([]);
        setTxtFileErr("กรุณาเช็คขนาดไฟล์ ไม่เกิน 3MB หรือ ชื่อไฟล์ห้ามเกิน 50 ตัวอักษร")
      }
      else if(!re.test(fileName))
      {
        setTxtFileErr("ไม่รองรับประเภทไฟล์นี้ กรุณาตรวจสอบอีกที")
        setFile([]);
      }
      else{
        setFile(event.target.files[0])
        setTxtFileErr("")
      }
      }
      else{
        setTxtFileErr("")
      }
    }
   const uploadFileToFirebase =  async (db,path) => {
    var bodyMail = "ข้อมูลส่วนบุคคลผู้ร้องเรียน ("+path+")<br>ชื่อ : "+ firstName +"<br>นามสกุล : " + lastName
    +"<br>ที่อยู่ : " + address +"<br>อำเภอ/เขต : " + district +"<br>ตำบล/แขวง : " + subDistrict
    +"<br>จังหวัด : " + province +"<br>รหัสไปรษณีย์ : " + postcode +"<br>หมายเลขโทรศัพท์ : " + telephone +"<br>อีเมล : " + email
    +"<br>ติดตามสถานอีเมล : " + followEmail  
    +'<br><br> รายละเอียดการร้องเรียน  '+'<br>เรื่องร้องเรียน : ' + appeal +'<br>วันที่เกิดเหตุ : '+ dateAcc 
    +"<br>สถานที่เกิดเหตุ : " + place +"<br>บริษัทที่เกี่ยวข้อง : " + company +"<br>บุคคลที่เกี่ยวข้อง : " + person +"<br>จังหวัด : " + provinceAcc 
    +"<br>มูลค่าของเงิน : " + amount +"<br>รายละเอียดการร้องเรียน : " + description  
    +"<br><br>เอกสารแนบ " + "<br>คำอธิบายเอกสาร : " + fileDescription 
    // +"<br><br>ข้อมูลการติดตามสถานะการร้องเรียน " +"<br>รหัสผ่าน (PIN) : " + pin

     if(file.length!==0)
     {
        const storeage = getStorage();
        const storageRef = ref(storeage,"Storage/"+path+'/'+file.name);
        
        uploadBytes(storageRef,file).then( async (snapshot)=>{
                   let fullUrl = "";
                   fullUrl = (await getDownloadURL(storageRef))

                   await addDoc(collection(db, 'mail'),{
                    to: email,
                    message: {
                      subject: 'แจ้งการร้องเรียน',
                      html: bodyMail,
                      attachments:[{
                        fileName:file.name,
                        path:fullUrl,
                        type:file.type
                      }]
                    },
                  })

                  await addDoc(collection(db, 'mail'),{
                    to: 'whistleblowing@tbn.co.th',
                    message: {
                      subject: 'แจ้งการร้องเรียน',
                      html: bodyMail,
                      attachments:[{
                        fileName:file.name,
                        path:fullUrl,
                        type:file.type
                      }]
                    },
                  })
        })
    }
    else{
      await addDoc(collection(db, 'mail'),{
        to: email,
        message: {
          subject: 'แจ้งการร้องเรียน',
          html: bodyMail,
        },
      })

      await addDoc(collection(db, 'mail'),{
        to: 'whistleblowing@tbn.co.th',
        message: {
          subject: 'แจ้งการร้องเรียน',
          html: bodyMail,
        },
      })

    }
   }
  const handleDateAcc = (e) => {
      setDateAcc(e.target.value);
  }
 
    useEffect( () => {
      document.title="TBN Co., Ltd."
    }, );

  return (
    <div className="TBN" style={{height:"100vh"}}>
      <header>
      <CNavbar style={{background:"#2B6EB6"}}>
      <div className="marginleft20 mt-2">
        <CImage src={logo} width={84} height={82.5} />
        </div>
      </CNavbar>
      </header>
        <div style={{minHeight:"100%"}}>
        <CContainer style={{color:"black"}} className="col-sm-8">
        <CRow className="mt-5">
          <CCol  lg={12}>
          <label className="TitleForm-tbn">แจ้งข้อร้องเรียนและเบาะแส</label>
          </CCol>
        </CRow>
        <label className="TitleHeader-tbn mt-4 mb-4">ผู้ร้องเรียน</label>
        <CForm target="_blank" className="row g-3 needs-validation" noValidate validated={validated} onSubmit={handleSubmit} > 
          <CCard>
            <CCardBody>
              <CRow className="ml-3">
              <label className="TitleCard-tbn">ข้อมูลส่วนบุคคล</label>
              <label className="subTitleCard-tbn">โปรดกรอกรายละเอียดเกี่ยวกับผู้แจ้ง (ข้อมูลนี้จะถูกเก็บเป็นความลับ)</label>
              </CRow>
              <CRow className="mt-4">
                <CCol sm={6}>
                  <CFormLabel className="form-label" >ชื่อ</CFormLabel>
                  <CFormInput className="inHeritStyle"  value={firstName} type="text" onChange={handleFirstName}/>
                </CCol>
                <CCol sm={6}>
                  <CFormLabel className="form-label" >นามสกุล</CFormLabel>
                  <CFormInput className="inHeritStyle" type="text" onChange={handleLastName}/>
                </CCol>
              </CRow>
              <CRow className="mt-4">
              <CCol sm={6}>
                <CFormLabel className="form-label" >ที่อยู่</CFormLabel>
                <CFormInput className="inHeritStyle" type="text" onChange={handleAddress}/>
                </CCol>
                <CCol sm={6}>
                  <CFormLabel className="form-label" >จังหวัด</CFormLabel>
                  <CFormSelect className="inHeritStyle" onChange={handleProvince}>
                  <option></option>
                  {listProvince}
                  </CFormSelect>
                </CCol>
              </CRow>
              <CRow className="mt-4">
              <CCol sm={6}>
                <CFormLabel className="form-label" >อำเภอ/เขต</CFormLabel>
                  <CFormSelect  disabled={checkDistrict} className="inHeritStyle" onChange={handleDistrict}>
                  <option></option>
                  {listDistrict}
                  </CFormSelect>
                </CCol>
                <CCol sm={6}>
                  <CFormLabel className="form-label" >ตำบล/แขวง</CFormLabel>
                  <CFormSelect  disabled={checkSubDistrict}  className=" form-select" onChange={handleSubDistrict}>
                  <option></option>
                  {listSubDistrict}
                  </CFormSelect>
                </CCol>
               
              </CRow>
              <CRow className="mt-4">
                <CCol sm={6}>
                  <CFormLabel className="form-label" >รหัสไปรษณีย์</CFormLabel>
                  <CFormInput className="inHeritStyle" type="text" onChange={handlePostcode} value={postcode}/>
                </CCol>
                <CCol sm={6}>
                  <CFormLabel className="form-label" >หมายเลขโทรศัพท์</CFormLabel>
                  <CFormInput className="inHeritStyle" type="text" onChange={handleTelephone} value={telephone}/>
                </CCol>
              </CRow>
              <CRow className="mt-4">
                <CCol sm={6}>
                  <CFormLabel className="form-label" >อีเมล</CFormLabel>
                  <CFormInput className="inHeritStyle" type="text" onChange={handleEmail}/>
                  <CFormLabel className="form-label subLabelGrey" >หากไม่ระบุท่านจะไม่สามารถับอีเมล์ติดตามสถานะข้อร้องเรียนได้</CFormLabel>
                </CCol>
              </CRow>
              <CRow className="mt-4">
                <CCol sm={12}>
              <CFormCheck  className="inHeritStyle" onChange={handleFollowEmail}label="ติดตามสถานะข้อร้องเรียนทางอีเมล์"/>
              </CCol>
              </CRow>
            </CCardBody>
          </CCard>
          <label>รายละเอียดการร้องเรียน</label>
          <CCard>
            <CCardBody>
              <CRow className="mt-4">
                <CCol sm={12}>
                  <CFormLabel className="form-label" >เรื่องร้องเรียน <label className="required">*</label></CFormLabel>
                  <CFormInput type="text" onChange={handleAppeal} required/>
                  <CFormFeedback invalid>กรุณาระบุเรื่องร้องเรียน</CFormFeedback>
                </CCol>
              </CRow>
              <CRow className="mt-4">
                <CCol sm={6}>
                  <CFormLabel className="form-label " htmlFor="validateCustom01">วันที่เกิดเหตุ หรือ พบเห็นเหตุการณ์ <label className="required">*</label></CFormLabel>
                
                  <input className="form-control" data-date-inline-picker="true"  onChange={handleDateAcc} type="date" value={dateAcc} placeholder="dd-MM-yyyy" locate="pt-br" format="dd-MM-yyyy" ></input >
                </CCol>
                <CCol sm={6}>
                  <CFormLabel className="form-label" htmlFor="validateCustom01">สถานที่เกิดเหตุ <label className="required">*</label></CFormLabel>
                  <CFormInput type="text" onChange={hanldePlace} required/>
                  <CFormFeedback invalid>โปรดระบุสถานที่เกิดเหตุ</CFormFeedback>
                </CCol>
              </CRow>
              <CRow className="mt-4">
                <CCol sm={6}>
                  <CFormLabel className="form-label" >บริษัทที่เกี่ยวข้อง</CFormLabel>
                  <CFormSelect className="inHeritStyle" onChange={handleCompany} >
                  <option></option>
                  {optionCompany}
                  </CFormSelect>
                </CCol>
                <CCol sm={6}>
                  <CFormLabel className="form-label" >บุคคลที่เกี่ยวข้อง</CFormLabel>
                  <CFormInput className="inHeritStyle" type="text"  onChange={handlePerson}/>
                
                </CCol>
              </CRow>
              <CRow className="mt-4">
                <CCol sm={6}>
                  <CFormLabel className="form-label" >จังหวัด</CFormLabel>
                  <CFormSelect className="inHeritStyle" onChange={handleProvinceAcc}>
                  <option></option>
                  {listProvince}
                  </CFormSelect>
                </CCol>
                <CCol sm={6}>
                  <CFormLabel className="form-label">มูลค่าของเงิน หรือ ทรัพย์สินที่เกี่ยวข้อง</CFormLabel>
                  <CFormInput type="text" className="inHeritStyle" onChange={handleAmount}/>
                 
                </CCol>
              </CRow>
              <CRow className="mt-4">
                <CCol sm={12}>
                  <CFormLabel className="form-label" >โปรดระบุรายละเอียดเรื่องร้องเรียน หรือ ลักษณะการกระทำการทุจริต <label className="required">*</label><label className="grey"> ไม่อนุญาตให้ใช้ตัวอักษรพิเศษ ( เช่น {specialText})</label></CFormLabel>
                  <CFormTextarea id="exampleFormControlTextarea1" rows="3" value={description} onChange={handleDescription} required></CFormTextarea>
                  <CFormFeedback invalid>โปรดระบุรายละเอียด</CFormFeedback>
                </CCol>
              </CRow>
              
            </CCardBody>
          </CCard>
          <label className="TitleCard">เอกสารแนบ</label>
          <label className="grey">นามสกุล DOC , DOCX , XLS , XLSX , PPT , PPTX , JPG , PNG , GIF , PDF</label>
          <label className="grey">ขนาดไม่เกิน 3 MB. ต่อ 1 ไฟล์ และความยาวชื่อไม่เกิน 50 ตัวอักษร</label>
          <CCard>
            <CCardBody>
              <CRow className="mt-4">
                <CCol sm={12}>
                <CFormLabel htmlFor="formFileMultiple">เอกสารแนบ</CFormLabel>
                <CFormInput className="inHeritStyle" type="file" id="formFileMultiple" onChange={fileSelected} multiple/>
                <label className="required" style={{fontSize:".875em"}}>{txtFileErr}</label>
                </CCol>
              </CRow>
              <CRow className="mt-4">
                <CCol sm={12}>
                  <CFormLabel className="form-label" >คำอธิบายเอกสารแนบ</CFormLabel>
                  <CFormInput type="text" className="inHeritStyle" onChange={handleFileDescription}/>
                  
                </CCol>
              </CRow>
            </CCardBody>
            </CCard>
            {/* <label className="TitleCard-tbn">ข้อมูลเพื่อการติดตามสถานะข้อร้องเรียน</label>
            <CCard>
            <CCardBody>
              <CRow className="mt-4">
              <label className="label-red">การติดตามสถานะข้อร้องเรียนจากเว็บไซต์นี้จะต้องใช้ <label className="bold-Red">รหัสผ่าน</label> และ <label className="bold-Red">"เลขที่ข้อร้องเรียน" (PIN)</label></label>
              <label className="label-red">โดยระบบจะสร้างเลขที่ข้อร้องเรียนให้ภายหลังจากกดปุ่ม <label className="bold-Red">"ส่งข้อมูล"</label></label>
              </CRow>
              <CRow className="mt-4">
                <CCol sm={6}>
                  <CFormLabel className="form-label" >กำหนดรหัสผ่าน (PIN)</CFormLabel>
                  <CFormInput type="password" className="inHeritStyle" onChange={handlePin}/>
                  
                  <label className="subLabelGrey">(ความยาวอย่างน้อย 8 ตัวอักษร)</label>
                  <label className="required" style={{fontSize:".875em"}}>{txtPinErr}</label>
                </CCol>
                <CCol sm={6}>
                  <CFormLabel className="form-label" >ยืนยันรหัสผ่าน (PIN)</CFormLabel>
                  <CFormInput type="password" className="inHeritStyle" onChange={handleConfirmPin}/>
                </CCol>
              </CRow>
            </CCardBody>
          </CCard> */}
          <CRow className="mt-4">
                <CCol className="colSpecial" >
              <CFormCheck   className="checkbox-tbn" required onChange={handleConsent}/>
              </CCol>
              <CCol className="col-sm-11">
              <label style={{paddingLeft:"5px"}}> ฉันได้อ่านและยอมรับข้อกำหนดและเงื่อนไขที่ระบุไว้ใน <label onClick={()=>setToggleConsentModal(true)} style={{color:"green",cursor:"pointer"}}><b><u>นโยบายคุ้มครองข้อมูลส่วนบุคคล</u></b></label> และยินยอมให้รวบรวมประมวลผลและ / หรือเปิดเผยข้อมูลส่วนบุคคลที่ฉันให้ไว้เพื่อบรรลุวัตถุประสงค์ดังกล่าวข้างต้น</label>
              </CCol>
          </CRow>
          <CRow className="d-flex justify-content-between mt-4">
            <CCol className="col-sm-6 mb-4" style={{paddingRight:"0px"}} >
          <CButton  className="col-sm-4 cancel-btn-tbn"  onClick={returnMain} style={{float:'right'}} size="lg"  >ยกเลิก</CButton>
          </CCol>
          <CCol className="col-sm-6 mb-4">
          <CButton  className="col-sm-4 color-btn-tbn"   type="submit" size="lg"  ><CIcon icon={cilSend} style={{marginRight:7.5}} size="lg"/>ส่งข้อมูล</CButton>
          </CCol>
          </CRow>
        </CForm>
        <CModal visible={toggleModal}>
          <CModalBody style={{textAlign:"center"}}> 
            <CImage src={circle}/>
            <CRow className="d-flex justify-content-between mt-4">
            <label><b>ระบบรับข้อร้องเรียนและแจ้งเบาะแสเรียบร้อยแล้ว</b></label>
            </CRow>
            <CRow className="d-flex justify-content-between mt-4">
            <label >เลขที่ข้อร้องเรียนของคุณ</label>
            </CRow> 
            <CRow className="d-flex justify-content-between mt-4">
            <label ><b>{refId}</b></label>
            </CRow> 
          <CButton  className="col-sm-4 color-btn-tbn mt-4 mb-4"  onClick={handleCloseModal} size="lg" >ปิด</CButton>
          </CModalBody>
        </CModal>

        <CModal visible={toggleConsentModal} size="lg">
          <CModalBody > 
            <CRow className="d-flex justify-content-between mt-4">
            <label className="mb-3"><b>การเปิดเผยข้อมูลส่วนบุคคลของท่าน</b></label>
            <label>- การเปิดเผยข้อมูลส่วนบุคคลของท่านให้กับบุคคลอื่น จะดำเนินการภายใต้วัตถุประสงค์ที่กำหนด หรือวัตถุประสงค์อื่นที่กฎหมายกำหนดให้กระทำได้เท่านั้น ในกรณีที่กฎหมายกำหนดว่าต้องได้รับความยินยอมจากท่าน ทั้งนี้บริษัทฯ จะขอความยินยอมโดยชัดแจ้งจากท่านก่อน</label>
            <label>- ในกรณีที่บริษัทฯ เปิดเผยข้อมูลส่วนบุคคลของท่านให้กับบุคคลอื่น บริษัทฯจะจัดให้มีมาตรการที่เหมาะสมเพื่อคุ้มครองข้อมูลส่วนบุคคลที่ได้เปิดเผยและเพื่อปฏิบัติตามมาตรฐานและหน้าที่การคุ้มครองข้อมูลส่วนบุคคล ตามที่กฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคลกำหนด</label>
            <label className="mt-3 mb-3"><b>ระยะเวลาในการเก็บรักษาข้อมูล</b></label>
            <label>บริษัทฯ จะเก็บรักษาข้อมูลส่วนบุคคลของท่านตามระยะเวลาที่จำเป็นเพื่อบรรลุวัตถุประสงค์ที่กำหนดในการประมวลผลข้อมูลส่วนบุคคลนั้น และเป็นไปตามที่กฎหมายที่เกี่ยวข้องกำหนด 
              โดยคำนึงถึงแนวปฏิบัติทางธุรกิจสำหรับแต่ละประเภทของข้อมูลส่วนบุคคล หลังจากระยะเวลาดังกล่าว กลุ่มบริษัทฯ อาจทำลายข้อมูลส่วนบุคคลเช่นว่านั้นจากการจัดเก็บหรือระบบของกลุ่มบริษัทฯ โดยไม่มีการแจ้งให้ท่านทราบล่วงหน้า</label>
            </CRow>
          <div style={{textAlign:"center"}}>
          <CButton  className="col-sm-3 color-btn-tbn mt-4 mb-4" style={{textAlign:"center"}}  onClick={()=>setToggleConsentModal(false)} size="lg" >ปิด</CButton>
          </div>
          </CModalBody>
        </CModal>


        </CContainer>
        
      </div>
     
    </div>
  );
}

export default TBNFormComplaint;

